module.exports = __webpack_public_path__ + "d7b60703bbbd39c131d5beba0fa17931.pdf";